import { cloneDeep } from '@apollo/client/utilities';
import { CompanyEntity } from '../common/entity';
import { OrderType } from '../order/order';

export class OrderSettings extends CompanyEntity {
  prefix?: string;
  suffix?: string;
  digits: number = 5;
  type: OrderType = OrderType.inbound;
  sendPushNotificationToAssignees: boolean = false;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, cloneDeep(obj));
  }
}
